<div class="dialog-wrapper">
  <div class="dialog-container">
    <app-static-page category="{{!!bonusName.category ? bonusName.category : 'bonus'}}" name="{{bonusName.pageName ? bonusName.pageName : bonusName}}" isDeposit="{{bonusName?.isFromDeposit}}" [standalone]="false"></app-static-page>
  </div>
  <app-close-dialog-button (closeEvent)="closeDialog()"></app-close-dialog-button>
</div>